import { render, staticRenderFns } from "./courseCatalogue.vue?vue&type=template&id=c3a06456&scoped=true&"
import script from "./courseCatalogue.vue?vue&type=script&lang=js&"
export * from "./courseCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./courseCatalogue.vue?vue&type=style&index=0&id=c3a06456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a06456",
  null
  
)

export default component.exports